import { createAction, props } from '@ngrx/store';

import { DataEjecucion } from '../../private/shared/models/menu-item';
import { IResultUpdateLegal } from '../../shared/models/Legales';
import {
    IResultAuthUserPhone,
    IResultConfig,
    IResultValidJwtBO,
    IResultValidJwtWA,
    IUserApp,
} from '../../shared/models/Tenderos.interface';


export const setUserInfoApp = createAction(
    '[SetUserInfoApp] Set User Info App',
    props<IUserApp>()
);

export const succesUserInfoApp = createAction(
    '[UserInfoApp] Set Bodega NUD more info success',
    props<{ ID_Bodega: number; NUD: number; }>()
);

export const setDateBD = createAction(
    '[SetDateBD] Set DateBD',
    props<{ DateBD: string; }>()
);

export const setEjecucion = createAction(
    '[SetEjecucion] Set User Info Ejecucion App',
    props<DataEjecucion>()
);

export const clearDataUser = createAction('[DataUser] Clear data user store');
export const clearDataUserSuccess = createAction('[DataUser] Clear data user store success');

/**
 * * Cancelacion de cuenta
 */
export const cancelAccount = createAction(
    '[CancelAccount] Cancel Account'
);

export const successCancelAccount = createAction(
    '[CancelAccount] Cancel Account Success',
    props<IResultUpdateLegal>()
);

export const errroCancelAccount = createAction(
    '[CancelAccount] Cancel Account Error',
    props<{ payload: Error }>()
);

export const resetCancelAccount = createAction(
    '[CancelAccount] Cancel Account Reset'
);

/**
 * * Validated Jwt Wa User
 */
export const validatedJwtWaUser = createAction(
    '[ValidatedJwtWaUser] Validated Jwt Wa User',
    props<{ Clave_Acceso: string; ID_Chat: number; }>()
);

export const successValidatedJwtWaUser = createAction(
    '[ValidatedJwtWaUser] Validated Jwt Wa User Success',
    props<IResultValidJwtWA>()
);

export const errroValidatedJwtWaUser = createAction(
    '[ValidatedJwtWaUser] Validated Jwt Wa User Error',
    props<{ payload: Error }>()
);

export const resetValidatedJwtWaUser = createAction(
    '[ValidatedJwtWaUser] Validated Jwt Wa User Reset'
);


/**
 * * Validated Jwt BO User
 */
export const validatedJwtBOUser = createAction(
    '[ValidatedJwtBOUser] Validated Jwt BO User',
    props<{ token: string }>()
);

export const successValidatedJwtBOUser = createAction(
    '[ValidatedJwtBOUser] Validated Jwt BO User Success',
    props<IResultValidJwtBO>()
);

export const errroValidatedJwtBOUser = createAction(
    '[ValidatedJwtBOUser] Validated Jwt BO User Error',
    props<{ payload: Error }>()
);

export const resetValidatedJwtBOUser = createAction(
    '[ValidatedJwtBOUser] Validated Jwt BO User Reset'
);

/**
 * * Genera un nuevo token
 */
export const authUserPhone = createAction(
    '[AuthUserPhone] Generated token Auth User Phone',
    props<{ Telefono: string; }>()
);

export const successAuthUserPhone = createAction(
    '[AuthUserPhone] Generated token Auth User Phone Success',
    props<IResultAuthUserPhone>()
);

export const errroAuthUserPhone = createAction(
    '[AuthUserPhone] Generated token Auth User Phone Error',
    props<{ payload: Error }>()
);

export const resetAuthUserPhone = createAction(
    '[ValidatedJwtWaUser] Generated token Auth User Phone Reset'
);

/**
 * * Obtiene variable de configuracion
 */
export const getConfig = createAction(
    '[GetConfig] Get configuration variable',
    props<{ LlaveConfiguracion: string; }>()
);

export const successGetConfig = createAction(
    '[GetConfig] Get configuration variable Success',
    props<IResultConfig>()
);

export const errroGetConfig = createAction(
    '[GetConfig] Get configuration variable Error',
    props<{ payload: Error }>()
);

export const resetGetConfig = createAction(
    '[ValidatedJwtWaUser] Get configuration variable Reset'
);
